import { render, staticRenderFns } from "./AddProductImage.vue?vue&type=template&id=6267f7f5&scoped=true&"
import script from "./AddProductImage.vue?vue&type=script&lang=js&"
export * from "./AddProductImage.vue?vue&type=script&lang=js&"
import style0 from "./AddProductImage.vue?vue&type=style&index=0&id=6267f7f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6267f7f5",
  null
  
)

export default component.exports